import { IUserOrganisation } from 'APIPackage/AccountModule/interfaces/IUserOrganisation';
import { IUserOrganisationSelectOption } from 'CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';

export const convertOrganisationToSelectOption = (organisation: IUserOrganisation): IUserOrganisationSelectOption => {
  const { fullName, id } = organisation;

  return {
    ...organisation,
    id: id.toString(),
    value: fullName,
    label: fullName,
  };
};
